import imageUrl1 from '../../../Assets/blogs/natural-west-2025-1.jpg';
import imageUrl2 from '../../../Assets/blogs/natural-west-2025-2.jpg';
import imageUrl3 from '../../../Assets/blogs/natural-west-2025-3.webp';

const post = {
  id: 'natural-products-expo-west-2025-recap',
  title: 'Natural Products Expo West 2025: Driving Zero-Waste Laundry Innovation',
  date: 'March 10, 2025',
  summary: 'At Expo West 2025, Klean Leaf showcased our bulk laundry detergent sheets, forged new eco-retail partnerships, and highlighted fast U.S. fulfillment from our Columbus office in just 3–5 days.',
  metaTags: {
    description: 'Recap of Klean Leaf’s Natural Products Expo West 2025 appearance, demonstrating bulk detergent sheets, zero-waste refill solutions, and fast shipping from our Columbus, Ohio office.',
    keywords: 'Expo West 2025, bulk detergent sheets, zero-waste laundry solutions, Columbus Ohio shipping, refill station supplies',
    author: 'Klean Leaf',
  },
  content: `
    <p>
      In March, at Anaheim’s <a href="https://www.expowest.com/en/home.html" aria-label="Expo West, laundry detergent strips manufacturer" target="_blank">Natural Products Expo West 2025</a>, Klean Leaf put our 
      eco-friendly laundry detergent sheets center stage. From 
      bulk sheet demos to in-depth talks on setting up 
      zero-waste refill stations, we reconnected with partners and welcomed dozens of new retailers.
    </p>

    <h2>Reconnecting with Zero-Waste Refill Leaders</h2>
    <ul>
      <li><strong>Proven partners:</strong> Longtime refill shops reported slashing plastic waste and boosting repeat visits after switching to our <em>bulk sheets</em>.</li>
      <li><strong>Custom station solutions:</strong> We brainstormed branded glass jars, kraft pouch labeling, and portion-control scales for an elevated refill experience.</li>
      <li><strong>Operational simplicity:</strong> One case (≈5,000 loose sheets) consolidates SKUs and frees up team time to focus on customer engagement.</li>
    </ul>
    <img src="${imageUrl3}" class="west-nature-image2 blog-content-image" alt="Expo West booth showcasing bulk detergent sheets">

    <h2>Welcoming New Sustainable Retailers</h2>
    <ul>
      <li><strong>First-time adopters:</strong> Natural grocery chains and eco-boutiques sampled our sheets and saw immediate cost savings versus liquid detergents.</li>
      <li><strong>Hands-on demos:</strong> Attendees loved tearing along the perforations or weighing sheets by the ounce—perfect for any <em>refill station</em>.</li>
      <li><strong>Search-ready branding:</strong> Retailers seeking “eco-friendly laundry sheets” found us at our booth, driving new wholesale inquiries and website traffic.</li>
    </ul>

    <h2>Collaborating for a Greener Planet</h2>
    <p>
      Expo West 2025 united personal-care innovators, compostable packaging pioneers, and sustainable home-care brands under one roof. Every conversation reinforced our mission: eliminate single-use plastics in laundry. By choosing our ultra-thin, water-soluble sheets, refill shops and retailers champion “<em>zero-waste cleaning</em>” and “<em>sustainable laundry solutions</em>” for environmentally conscious customers.
    </p>
    <img src="${imageUrl2}" class="west-nature-image2 blog-content-image" alt="Networking at Expo West 2025">

    <h2>Fast U.S. Fulfillment from Columbus</h2>
    <p>
      All orders ship directly from our Columbus, Ohio office—no middlemen, no delays. Expect reliable 3–5 day lead times to any city in the U.S., so your refill station stays stocked and your customers keep coming back.
    </p>

    <h2>Join the Bulk Sheet Movement</h2>
    <p>
      Missed Expo West? Request free samples of our <em>bulk laundry detergent sheets</em> today and discover how to transform your refill station into a zero-waste laundry destination. Partner with Klean Leaf for competitive pricing, custom labeling, and fast, coast-to-coast shipping.
    </p>
  `,
  imageUrl1,
  imageUrl2,
};

export default post;
